import React, {useEffect} from 'react';
import config from 'config';
import { useAppDispatch, useAppState } from 'context/AppContext';
import { getAppStatus } from 'context/AppContext/middleware';
import styles from './style/applicationStatus.module.css';

function ApplicationStatus() {
  const { applicationStatus } = useAppState();
  const dispatch = useAppDispatch();
  const appIsLive = applicationStatus === 'Live';

  useEffect(() => {
    getAppStatus({ dispatch });
    const status = setInterval(() => {
      getAppStatus({ dispatch });
    }, config.appStatusInterval);

    return function cleanup() {
      clearInterval(status);
    };
  }, [dispatch]);

  return (
    <div className={styles.applicationStatus}>
      <span className={!appIsLive ? styles.offline : ''} />
      {appIsLive ? 'Sales Order App' : 'Offline'}
    </div>
  );
}

export default ApplicationStatus;
